export interface PathObject {
  section: string;
  subsection: string | null | undefined;
  action: string | null | undefined;
}

export interface RouteService {
  currentLocation: () => Location;
  currentPathObj: () => PathObject;
  isUserOnProjects: () => boolean;
  isUserOnJobs: () => boolean;
}

export default function useRouteService(): RouteService {
  const currentLocation: () => Location = () => window.location;
  const currentPathObj = (): PathObject => {
    const path = window.location.pathname;
    const pathArr = path.split("/");
    return {
      section: pathArr[1] || "",
      subsection: pathArr[2] || null,
      action: pathArr[3] || null,
    };
  };
  const isUserOnProjects = (): boolean => {
    const path = window.location.pathname;
    return path.includes('projects')
  };
  const isUserOnJobs = (): boolean => {
    const path = window.location.pathname;
    return path.includes('jobs')
  }

  return { currentLocation, currentPathObj, isUserOnProjects, isUserOnJobs };
}
